import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_38_95_4W_38_95',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_38_95_4w_38_95_usd',
			ARS: 'simple_premium_4w_51890_4w_51890_ars',
			COP: 'simple_premium_4w_157390_4w_157390_cop',
			CLP: 'simple_premium_4w_37690_4w_37690_clp',
		},
		primer: 'prd_BUeOruAJb99s',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 4,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 38.95,
			ARS: 51890,
			COP: 157390,
			CLP: 37690,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 38.95,
			ARS: 51890,
			COP: 157390,
			CLP: 37690,
		},
	},
}
